import { render, staticRenderFns } from "./ReviewFormLinkDialog.vue?vue&type=template&id=5dae6bf5&scoped=true&"
import script from "./ReviewFormLinkDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewFormLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFormLinkDialog.vue?vue&type=style&index=0&id=5dae6bf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae6bf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
